module.exports = __webpack_public_path__ + "static/media/bi_symbol_image_black.c83e0134.png";